accounts-pendo-analytics {
    /* Component styles go here */
}
